// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownFilters_wrapper__ZnEuy","filter":"DropdownFilters_filter__grcB9","alternatives":"DropdownFilters_alternatives__1Zq3q"};